<template>
  <div class="footer">
    Copyright Reserved 2000-2013 雅昌艺术网 版权所有
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
.footer {
  padding-top: 10px;
  height: 50px;
  font-size: 12px;
  text-align: center;
  color: #666666;
  border-top: 1px solid #ddd;
}
</style>